var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-footer",on:{"click":function($event){return _vm.onDownClick()}}},[_c('span',[_vm._v("打开足趣社区，看更多相关精彩视频")])])}
var staticRenderFns = []

export { render, staticRenderFns }